import { clsx } from 'clsx';
import { createElement } from 'react';
import type { ComponentPropsWithoutRef } from 'react';

export type ContainerSize = 'content' | 'narrow' | 'full';
type ContainerTag = 'div' | 'section' | 'header' | 'footer' | 'main' | 'nav' | 'article';

export interface ContainerProps extends ComponentPropsWithoutRef<'div'> {
  /** Element to render (default `div`). */
  as?: ContainerTag;
  /** `content` (default): ≤ 1240 px of content between the page gutters · `narrow`: reading width · `full`: unconstrained. */
  size?: ContainerSize;
}

/** Page-width wrapper: centred, fluid side gutters (28 → 72 px), content capped at `--content-max`. */
export function Container({ as = 'div', size = 'content', className, ...props }: ContainerProps) {
  return createElement(as, {
    className: clsx('container-page', className),
    'data-size': size === 'content' ? undefined : size,
    ...props,
  });
}
